import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSortArrowUpDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSortArrowUpDown"><Path d="M18 2.89771L13.6901 7.53917L14.7893 8.55985L17.25 5.90982V18.09L14.7893 15.44L13.6901 16.4607L18 21.1021L22.3099 16.4607L21.2107 15.44L18.75 18.09V5.90982L21.2107 8.55985L22.3099 7.53917L18 2.89771Z" fill="currentColor"/><Path d="M3 2.99992V10.9999H11V2.99992H3Z" fill="currentColor"/><Path d="M3 12.9999V20.9999H11V12.9999H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSortArrowUpDown;
